<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li v-for="(item,index) in partnerOrdersInfo.partners" :key="index"
              @click="swatchPartner(item)"
              :class="{'selected':partnerOrdersInfo.conditions.ppId == item.ppId}">
              {{item.partnerName}}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('partnerOrders.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input
                :placeholder="$t('partnerOrders.orderIdPlaceholder')"
                v-model="partnerOrdersInfo.conditions.orderId"
                clearable
                style="width:200px"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                :placeholder="$t('partnerOrders.personNamePlaceholder')"
                v-model="partnerOrdersInfo.conditions.personName"
                clearable
                style="width:200px"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                :placeholder="$t('partnerOrders.personTelPlaceholder')"
                v-model="partnerOrdersInfo.conditions.personTel"
                clearable
                style="width:200px"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryPartnerGoodsMethod()">
                <i class="el-icon-search"></i>
                {{ $t('partnerOrders.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('partnerOrders.partnerOrders') }}</span>
          </div>
          <el-table
            :data="partnerOrdersInfo.partnerOrderss"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="transactionId"
              :label="$t('partnerOrders.transactionId')"
              align="center"
            />
            <el-table-column
              prop="orderId"
              :label="$t('partnerOrders.orderId')"
              align="center"
            />
            <el-table-column
              prop="refund"
              :label="$t('partnerOrders.refund')"
              align="center"
            >
              <template #default="{row}">
                {{row.refund=='Y'?$t('partnerOrders.yes'):$t('partnerOrders.no')}}
              </template>
            </el-table-column>
            <el-table-column
              prop="totalPrice"
              :label="$t('partnerOrders.totalPrice')"
              align="center"
            />
            <el-table-column
              prop="personName"
              :label="$t('partnerOrders.personName')"
              align="center"
            >
              <template #default="{row}">
                {{row.personName || '-'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="personTel"
              :label="$t('partnerOrders.personTel')"
              align="center"
            >
              <template #default="{row}">
                {{row.personTel || '-'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="channel"
              :label="$t('partnerOrders.channel')"
              align="center"
            >
              <template #default="{row}">
                {{row.channel || '-'}}
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              :label="$t('partnerOrders.createTime')"
              align="center"
            />
            <el-table-column
              prop="state"
              :label="$t('partnerOrders.state')"
              align="center"
            >
              <template #default="{row}">
                {{row.state == 'Y'?$t('partnerOrders.syncSuccess'):$t('partnerOrders.syncFail')}}
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              :label="$t('partnerOrders.remark')"
              align="center"
            >
              <template #default="{row}">
                {{row.remark || '-'}}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('partnerOrders.operation')"
              align="center"
              width="150"
            >
              <template #default="{row}">
                <el-button
                  size="mini"
                  @click="_toOrderDetail(row)"
                >{{ $t('partnerOrders.detail') }}</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="partnerOrdersInfo.conditions.page"
            :page-size="partnerOrdersInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="partnerOrdersInfo.total"
            style="margin-top: 20px; text-align: right;"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listPartnerOrder, listPartnerPool } from '@/api/partner/partnerOrdersApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'PartnerOrders',
  data() {
    return {
      loading: false,
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      partnerOrdersInfo: {
        partnerOrderss: [],
        partners: [],
        total: 0,
        records: 1,
        moreCondition: false,
        pgId: '',
        conditions: {
          ppId: '',
          orderId: '',
          personName: '',
          personTel: '',
          state: '',
          page: 1,
          row: 10,
          shopId: ''
        }
      }
    }
  },
  created() {
    this.partnerOrdersInfo.conditions.shopId = getShopId()
    this._listPartners()
  },
  methods: {
    handleCurrentChange(val) {
      this._listPartnerOrderss(val, this.DEFAULT_ROWS)
    },
    _listPartnerOrderss(_page, _rows) {
      this.loading = true
      this.partnerOrdersInfo.conditions.page = _page
      this.partnerOrdersInfo.conditions.row = _rows
      
      listPartnerOrder(this.partnerOrdersInfo.conditions)
        .then(res => {
          this.partnerOrdersInfo.total = res.total
          this.partnerOrdersInfo.records = res.records
          this.partnerOrdersInfo.partnerOrderss = res.data
        })
        .catch(err => {
          console.log('请求失败处理', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    _queryPartnerGoodsMethod() {
      this._listPartnerOrderss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _moreCondition() {
      console.log(this.partnerOrdersInfo.moreCondition)
      this.partnerOrdersInfo.moreCondition = !this.partnerOrdersInfo.moreCondition
    },
    _toOrderDetail(_order) {
      this.$router.push(`/pages/goods/storeOrderCartDetail?orderId=${_order.orderId}`)
    },
    _listPartners() {
      const params = {
        page: 1,
        row: 100,
        shopId: getShopId()
      }
      
      listPartnerPool(params)
        .then(res => {
          this.partnerOrdersInfo.partners = res.data
          if(res.data && res.data.length > 0) {
            this.partnerOrdersInfo.conditions.ppId = res.data[0].ppId
            this._listPartnerOrderss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
          }
        })
        .catch(err => {
          console.log('请求失败处理', err)
        })
    },
    swatchPartner(item) {
      this.partnerOrdersInfo.conditions.ppId = item.ppId
      this._listPartnerOrderss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>